import { render, staticRenderFns } from "./inspectionAddpoint.vue?vue&type=template&id=5cc3a7f8&scoped=true&"
import script from "./inspectionAddpoint.vue?vue&type=script&lang=js&"
export * from "./inspectionAddpoint.vue?vue&type=script&lang=js&"
import style0 from "./inspectionAddpoint.vue?vue&type=style&index=0&id=5cc3a7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3a7f8",
  null
  
)

export default component.exports